import Vue from 'vue';
import App from './App.vue';
import '@progress/kendo-theme-default/dist/all.css';
import router from './router';
import store from './store/store.js';
import VueHaptic from 'vue-haptic';
import VueI18n from 'vue-i18n';
import FlagIcon from 'vue-flag-icon';
import messages from './lang';

Vue.config.productionTip = true;

Vue.use(VueHaptic, {
    // Required. vue-haptic does not provide
    // any out-of-the-box patterns
    patterns: {
        success: [10, 100, 30],
        failure: [10, 50, 10, 50, 50, 100, 10],
        long: 200,
        default: 10,
    },
});
Vue.use(VueI18n);
Vue.use(FlagIcon);

export const i18n = new VueI18n({
    locale: 'de',
    fallbackLocale: 'de',
    messages
});

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');
